import { TextContainer } from 'components/container'
import { Video } from 'components/video'

export const PageIntro = () => (
  <TextContainer>
    <p>
      Саха, или якуты, – коренной народ Северо-Восточной Сибири, проживающий преимущественно в крупнейшем регионе России, Республике Саха (Якутия). В этой серии проекта “Анализируй Этно” мы послушаем уникальный саха панк, который развивался практически в полной изоляции. Встретимся с известным антивоенным активистом – Айхалом Аммосовым. Узнаем об особенностях игры на древнем музыкальном инструменте – хомусе. Посмотрим кино с режиссеркой Людмилой Борисовой и узнаем больше о феномене саха кинематографа. А также узнаем, как жители Якутска живут в изоляции каждый раз, когда река Лена замерзает.
    </p>

    <Video
      id="7OsMOni1GyY"
      poster="https://gdb.currenttime.tv/01000000-0aff-0242-931b-08dc29a991ac_w1920.jpg"
    />
  </TextContainer>
)
